export default __webpack_public_path__ + "static/media/news-11.d3c71ad6.jpg";